// src/components/ReadjudicacionMasiva/Dashboard/LotesFilters.js

import React, { useState } from 'react';
import {
    Paper,
    Grid,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    IconButton,
    Collapse,
    Typography
} from '@mui/material';
import {
    Search as SearchIcon,
    FilterList as FilterListIcon,
    Clear as ClearIcon,
    ExpandMore as ExpandMoreIcon,
    ExpandLess as ExpandLessIcon
} from '@mui/icons-material';

const LotesFilters = ({ filtros, onFiltrosChange, onBuscar, onLimpiar }) => {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (campo) => (event) => {
        onFiltrosChange({
            ...filtros,
            [campo]: event.target.value
        });
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            onBuscar();
        } else if (event.key === 'Escape') {
            onLimpiar();
        }
    };

    return (
        <Paper sx={{ p: 1, mb: 1, borderRadius: '4px' }}>
            <div
                onClick={() => setExpanded(!expanded)}
                style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '2px 4px' }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <FilterListIcon color="action" fontSize="small" />
                    <Typography variant="body1" fontWeight={500}>
                        Filtros de Búsqueda
                    </Typography>
                </div>
                <IconButton size="small">
                    {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                </IconButton>
            </div>

            <Collapse in={expanded}>
                <Grid container spacing={1} sx={{ mt: 0.5 }} onKeyDown={handleKeyPress}>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <TextField
                            label="Buscar"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={filtros.busqueda || ''}
                            onChange={handleChange('busqueda')}
                            onKeyDown={handleKeyPress}
                            placeholder="Lote o Expediente"
                            InputProps={{
                                endAdornment: <SearchIcon color="action" fontSize="small" />
                            }}
                        />
                    </Grid>
                    <Grid size={{ xs: 6, md: 2 }}>
                        <FormControl variant="outlined" size="small" fullWidth>
                            <InputLabel>Estado</InputLabel>
                            <Select
                                value={filtros.estado !== undefined ? filtros.estado : ''}
                                onChange={handleChange('estado')}
                                label="Estado"
                            >
                                <MenuItem value="">Todos</MenuItem>
                                <MenuItem value={0}>Pend. Auditoría</MenuItem>
                                <MenuItem value={1}>Auditado</MenuItem>
                                <MenuItem value={2}>Desapoderado</MenuItem>
                                <MenuItem value={3}>Asignado</MenuItem>
                                <MenuItem value={4}>Listo para Pasaje</MenuItem>
                                <MenuItem value={5}>Finalizado</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 6, md: 2 }}>
                        <TextField
                            label="Desde"
                            type="date"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={filtros.fechaDesde || ''}
                            onChange={handleChange('fechaDesde')}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid size={{ xs: 6, md: 2 }}>
                        <TextField
                            label="Hasta"
                            type="date"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={filtros.fechaHasta || ''}
                            onChange={handleChange('fechaHasta')}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid size={{ xs: 6, md: 3 }} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Button
                            variant="contained"
                            size="small"
                            startIcon={<SearchIcon />}
                            onClick={onBuscar}
                        >
                            Buscar
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<ClearIcon />}
                            onClick={onLimpiar}
                        >
                            Limpiar
                        </Button>
                    </Grid>
                </Grid>
            </Collapse>
        </Paper>
    );
};

export default LotesFilters;
